import {
  createMigrate,
  PersistConfig,
  PersistedState,
  persistReducer,
  PersistState
} from 'redux-persist';
import { rootReducer } from './reducers';
import { clone, set } from 'lodash';
import {
  BuyerDashboardState,
  initialDashboardState
} from './stores/buyer-dashboard';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

export type RootState = ReturnType<typeof rootReducer>;

const whitelistPersist: (keyof RootState)[] = ['buyer-dashboard', 'metadata'];

const migrations = {
  '0': (state: PersistedState) => {
    if (typeof state === 'undefined') {
      return { _persist: { version: -1, rehydrated: false } };
    }

    const newState = clone(
      state as {
        ['buyer-dashboard']: { pagination: { filter: {} } };
        _persist: PersistState;
      }
    );

    set(newState, 'buyer-dashboard', initialDashboardState);
    return newState;
  },
  '1': (state: PersistedState) => {
    if (typeof state === 'undefined') {
      return { _persist: { version: -1, rehydrated: false } };
    }

    const newState = clone(
      state as {
        ['buyer-dashboard']: { pagination: { filter?: {} | undefined } };
        _persist: PersistState;
      }
    );

    set(newState, 'buyer-dashboard', initialDashboardState);
    delete newState['buyer-dashboard'].pagination.filter;

    return newState;
  },
  '2': (state: PersistedState) => {
    if (typeof state === 'undefined') {
      return { _persist: { version: -1, rehydrated: false } };
    }

    const newState = clone(
      state as {
        ['buyer-dashboard']: BuyerDashboardState;
        _persist: PersistState;
      }
    );

    // initialDashboardState got modified between version 1 and 2
    set(newState, 'buyer-dashboard', initialDashboardState);

    return newState;
  },
  '3': (state: PersistedState) => {
    if (typeof state === 'undefined') {
      return { _persist: { version: -1, rehydrated: false } };
    }
    const newState = clone(
      state as {
        ['agent-proforma']: Record<string, string> | undefined;
        _persist: PersistState;
      }
    );

    delete newState['agent-proforma'];

    return newState;
  }
};

const persistConfig: PersistConfig<RootState> = {
  key: 'root',
  storage,
  whitelist: whitelistPersist as string[],
  version: 1,
  migrate: createMigrate(migrations, {
    debug: true
  })
};

export const persistedReducer = persistReducer(persistConfig, rootReducer);
